import { forwardRef, InputHTMLAttributes, ReactNode } from "react";
import { IconButton } from "../button/icon-button";
import { ClearIcon } from "../icon";
import { cn } from "../../lib/utils";

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  iconInput?: ReactNode;
  onClear?: () => void;
  error?: boolean;
};

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    { className, type = "text", iconInput, error, value, onClear, ...props },
    ref
  ) => {
    return (
      <div className="relative w-full">
        <input
          ref={ref}
          value={value}
          type={type}
          className={cn(
            `border disabled:text-gray-500 border-neutral-200 group-invalid:border-negative-500 rounded-[10px] flex items-center focus:border-neutral-600 focus:outline-none disable px-3 bg-transparent w-full h-full p-2.5 disabled:bg-neutral-200 invalid:border-pink-500 invalid:text-pink-60 focus:invalid:border-pink-500 focus:invalid:ring-pink-500`,
            { "pr-8": !!iconInput || !!onClear },
            className
          )}
          {...props}
        />

        {!onClear && iconInput && (
          <div className="flex items-center absolute h-full top-0 right-0 pr-3">
            <div className="w-4 h-4">{iconInput}</div>
          </div>
        )}

        {!iconInput && !!value && onClear && (
          <IconButton
            className="flex items-center absolute h-full top-0 right-3"
            onClick={onClear}
          >
            <div className="w-4 h-4">{<ClearIcon />}</div>
          </IconButton>
        )}
      </div>
    );
  }
);
